import React from 'react'
import T from 'prop-types'
import { Button, Stack } from '@mui/material'

export default function SessionsDownloadTemplate({
  label,
  handleDownload,
  disabled,
}) {
  return (
    <Stack direction="row" justifyContent="center">
      <Button
        color="secondary"
        variant="contained"
        onClick={handleDownload}
        disabled={disabled}
      >
        {label}
      </Button>
    </Stack>
  )
}

SessionsDownloadTemplate.propTypes = {
  label: T.string,
  handleDownload: T.func,
  disabled: T.bool,
}
